/**
 * New Blog Listing Section JavaScript
 * Handles tab switching for blog posts
 */

class NewBlogListing {
  constructor() {
    this.currentTab = null;
    this.isLoading = false;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadInitialTab();
  }

  bindEvents() {
    // Tab button clicks
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-tab]')) {
        e.preventDefault();
        this.switchTab(e.target.dataset.tab);
      }
    });

    // Handle browser back/forward
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.tab) {
        this.switchTab(e.state.tab, false);
      }
    });
  }


  loadInitialTab() {
    const activeTab = document.querySelector('.new-blog-listing__tab-btn--active');
    if (activeTab) {
      this.switchTab(activeTab.dataset.tab);
    }
  }


  switchTab(tabHandle, updateHistory = true) {
    if (this.isLoading || this.currentTab === tabHandle) return;

    this.isLoading = true;
    this.currentTab = tabHandle;

    // Update active tab button
    this.updateActiveTab(tabHandle);

    // Update URL
    if (updateHistory) {
      const url = new URL(window.location);
      url.searchParams.set('tab', tabHandle);
      history.pushState({ tab: tabHandle }, '', url);
    }

    this.isLoading = false;
  }


  updateActiveTab(tabHandle) {
    // Remove active class from all tabs
    document.querySelectorAll('.new-blog-listing__tab-btn').forEach(btn => {
      btn.classList.remove('new-blog-listing__tab-btn--active');
      btn.setAttribute('aria-selected', 'false');
    });

    // Add active class to current tab
    const activeBtn = document.querySelector(`[data-tab="${tabHandle}"]`);
    if (activeBtn) {
      activeBtn.classList.add('new-blog-listing__tab-btn--active');
      activeBtn.setAttribute('aria-selected', 'true');
    }

    // Hide all tab panels
    document.querySelectorAll('.new-blog-listing__tab-panel').forEach(panel => {
      panel.classList.remove('new-blog-listing__tab-panel--active');
      panel.style.display = 'none';
    });

    // Show current tab panel
    const activePanel = document.querySelector(`[data-tab-panel="${tabHandle}"]`);
    if (activePanel) {
      activePanel.classList.add('new-blog-listing__tab-panel--active');
      activePanel.style.display = 'block';
    }
  }

}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Check if we're on a page with the new blog listing section
  if (document.querySelector('[data-wetheme-section-type="new-blog-listing"]')) {
    new NewBlogListing();
  }
});

// Handle URL parameters on page load
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  
  if (tabParam) {
    // Wait a bit for the component to initialize
    setTimeout(() => {
      const tabBtn = document.querySelector(`[data-tab="${tabParam}"]`);
      if (tabBtn) {
        tabBtn.click();
      }
    }, 100);
  }
});
